export const Header1 = `<div class=" experience-details">
            <div class="d-flex justify-content-between">
                <div class="experience-role"></div>
                <div class="experience-date"></div>
            </div>
            <div class="d-flex justify-content-between">
			<div  class="experience-company"></div>
					<div  class="experience-location"></div>
            </div>
        </div> <hr class="experience-hr"/> <div  class="experience-description"></div>`;

export const Header3 = `
<div class="experience-inner-item"><div class=" experience-details">
                <div class="experience-date"></div>
            </div>
            <div class="experience-without-date">
			<div class="experience-role"></div>
			<span  class="experience-company"></span>
			<span  class="experience-location"></span>
			<div  class="experience-description"></div>
            </div></div>`;
